import { useState, useEffect } from "react";
import { ReportAPI } from "../../../../axios/api";
import { useAbortedEffect } from "../../../../components/hooks";
import moment from "moment";

import {
  useSearchFilter,
  ModuleSearchFilterWrap,
} from "../../../../components/searchFilter";
import ModuleSectionBlock from "../../../../components/sectionBlock";
import { ModuleTable, useTable } from "../../../../components/table";
import { decimalAddZero } from "../../../../service/common";

const totalEnergyTemplate = (rowData) =>
  decimalAddZero({
    rawVal: rowData.totalEnergy,
    decimalCount: 2,
  });

export default function ModuleCustomChartElectricityList() {
  const [reload, setReload] = useState(true);
  const [apiData, setApiData] = useState([]);
  const tbOptions = useTable();
  const { setTbColumns } = tbOptions;
  const { filterData, searchData, setSearchData, changeFilter } =
    useSearchFilter({
      defaultFilter: {
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      searchKey: ["usageStatistic"],
      reloadAction: () => setReload(true),
    });
  const filterColumns = [
    {
      ui: "calendar",
      uiClassName: "w-9rem",
      label: "起始",
      params: {
        name: "startDate",
        // maxKey: "endDate",
        dateEffectKey: "endDate",
        dateDirection: "start",
        dateEffectNumber: null,
        dateEffectUnit: "months",
      },
    },
    {
      ui: "calendar",
      uiClassName: "w-9rem",
      label: "結束",
      params: {
        name: "endDate",
        // minKey: "startDate",
        dateEffectKey: "startDate",
        dateDirection: "end",
        dateEffectNumber: null,
        dateEffectUnit: "months",
      },
    },
  ];

  useAbortedEffect(
    (signal) => {
      if (!reload) return;

      const params = {
        startDate: searchData.startDate,
        endDate: searchData.endDate,
      };

      ReportAPI.getMonthlyEnergyList({
        options: { signal },
        data: params,
      }).then((result) => {
        let { Response, data } = result;

        if (Response === 1) {
          formatHandler({ data });
          setReload(false);
        }
      });
    },
    [reload],
  );

  const formatHandler = ({ data }) => {
    const formatData = data.map((item) => ({
      month: item.month?.replace("-", "/") ?? "",
      energy: item.energyName || "其他",
      totalEnergy:
        Math.round(((Number(item.totalEnergy) || 0) + Number.EPSILON) * 100) /
        100,
    }));

    setApiData(formatData);
    tbOptions.setTbData(formatData);
    tbOptions.setTbTotalRecords(formatData.length);
  };

  useEffect(() => {
    let columns = [
      {
        field: "month",
        header: "月份",
        className: "flex-grow-1",
        exportOptions: {
          width: 10,
        },
      },
      {
        field: "energy",
        header: "用電設備",
        className: "flex-grow-1",
        exportOptions: {
          width: 14,
        },
      },
      {
        field: "totalEnergy",
        header: "累積用電量(kWh)",
        className: "flex-grow-1",
        body: totalEnergyTemplate,
        exportOptions: {
          width: 20,
        },
      },
    ];
    setTbColumns(columns);
  }, [setTbColumns]);

  return (
    <ModuleSectionBlock
      isExpand={false}
      title="電力累積統計"
      isExport={true}
      exportOptions={[
        {
          isList: true,
          listOptions: [
            {
              listColumns: tbOptions.tbColumns,
              listData: apiData,
              listPos: { x: 0, y: 1 },
            },
          ],
        },
      ]}
      overlaySetting={[
        {
          icon: "pi pi-filter",
          template: (
            <ModuleSearchFilterWrap
              className="w-auto text-white"
              columns={filterColumns}
              filterData={filterData}
              setSearchData={setSearchData}
              changeFilter={changeFilter}
            />
          ),
        },
      ]}
      bodyTemplate={<ModuleTable hookOptions={tbOptions} />}
    />
  );
}
